// extracted by mini-css-extract-plugin
export default {"root":"Topic_root__FOrpT","text":"Topic_text__vNsXp","pinIcon":"Topic_pinIcon__sLJbS","updatedAt":"Topic_updatedAt__nEpZv"};